export enum PixKeyType {
    CNPJ = 1,
    Email = 2,
    Telephone = 3
}